<button id="historyModalBtn" data-toggle="modal" data-target="#deviceHistory_modal" [hidden]="true">
  History Modal
</button>

<div data-keyboard="false" data-backdrop="static" id="deviceHistory_modal" class="modal fade">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content dh-modal__content">
      <header class="dh-modal__header">
        <div class="dh-modal__title-wrap">
          <span class="dh-modal__icon" aria-hidden="true">
            <i class="fa fa-history"></i>
          </span>
          <h5 class="dh-modal__title">Device History</h5>
        </div>
        <button
          type="button"
          id="closeHistoryModal"
          class="dh-modal__close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="onClose()"
          (mousedown)="$event.preventDefault()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="dh-modal__body">
        <div class="dh-summary">
          <div class="dh-summary__item">
            <span class="dh-summary__icon" aria-hidden="true">
              <i class="fa fa-bolt-lightning"></i>
            </span>
            <div class="dh-summary__meta">
              <span class="dh-summary__label">Campaign Name</span>
              <strong class="dh-summary__value">{{ campaignName }}</strong>
            </div>
          </div>
          <div class="dh-summary__item">
            <span class="dh-summary__icon" aria-hidden="true">
              <i class="fa fa-microchip"></i>
            </span>
            <div class="dh-summary__meta">
              <span class="dh-summary__label">Serial Number</span>
              <strong class="dh-summary__value">{{ device.serialNumber }}</strong>
            </div>
          </div>
          <div class="dh-summary__item">
            <span class="dh-summary__icon" aria-hidden="true">
              <i class="fa fa-repeat"></i>
            </span>
            <div class="dh-summary__meta">
              <span class="dh-summary__label">Trigger Count</span>
              <strong class="dh-summary__value">{{ deviceHistory.length }}</strong>
            </div>
          </div>
          <button
            type="button"
            class="dh-summary__export"
            ngbTooltip="Export CSV"
            placement="top"
            [disabled]="!deviceHistory.length"
            (click)="exportActivityCSV()"
            aria-label="Export CSV">
            <i class="fa fa-cloud-download" aria-hidden="true"></i>
          </button>
        </div>

        @if (deviceHistoryView.length) {
          <div class="dh-list scrollable-modal-body">
            @for (data of deviceHistoryView; track data) {
              <div class="dh-stage">
                <div class="dh-stage__info">
                  <span class="dh-stage__badge">Stage - {{ data.stage }}</span>
                  <div class="dh-stage__meta">
                    <span class="dh-stage__author" ngbTooltip="Scheduled By">
                      <i class="fa fa-user" aria-hidden="true"></i>
                      <span>{{ data.scheduledBy }}</span>
                    </span>
                    <span class="dh-stage__time" ngbTooltip="Processing Time">
                      <i class="fa fa-clock-o" aria-hidden="true"></i>
                      @if (data.totalTime) {
                        <span>{{ data.totalTime | secondsToHms: 'milliseconds' }}</span>
                      }
                      @if (!data.totalTime) {
                        <span>--</span>
                      }
                    </span>
                  </div>
                </div>

                <ul class="dh-timeline">
                  <li
                    style="z-index: 5;"
                    [class.scheduled]="data.status==='RETRY' || data.status==='SYSTEM_RETRY' || data.status==='SCHEDULED'"
                    [class.commandSent]="data.status==='COMMAND_SENT'"
                    [class.inProgress]="data.status==='PROGRESS'"
                    [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                    [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                    [class.cancelled]="data.status==='CANCELLED'"
                    [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                    <div class="status">
                      @if (data.status==='RETRY' || data.status==='SYSTEM_RETRY') {
                        <span>Retry</span>
                      }
                      @if (data.status!=='RETRY' && data.status!=='SYSTEM_RETRY') {
                        <span>Scheduled</span>
                      }
                    </div>
                    <div class="status-dot"></div>
                    <div class="timestamp">
                      <span class="date">{{ data.scheduleAt | date: dateFormat }}</span>
                    </div>
                  </li>

                  <li
                    style="z-index: 4;"
                    [class.commandSent]="data.status==='COMMAND_SENT'"
                    [class.inProgress]="data.status==='PROGRESS'"
                    [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                    [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                    [class.cancelled]="data.status==='CANCELLED'"
                    [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                    <div class="status">
                      <span>Command Sent</span>
                    </div>
                    <div class="status-dot"></div>
                    @if (data.commandSentAt) {
                      <div class="timestamp">
                        <span class="date">{{ data.commandSentAt | date: dateFormat }}</span>
                      </div>
                    }
                  </li>

                  <li
                    style="z-index: 3;"
                    [class.inProgress]="data.status==='PROGRESS'"
                    [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                    [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                    [class.cancelled]="data.status==='CANCELLED'"
                    [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                    <div class="status">
                      <span>In Progress</span>
                    </div>
                    <div class="status-dot"></div>
                    @if (data.progressAt) {
                      <div class="timestamp">
                        <span class="date">{{ data.progressAt | date: dateFormat }}</span>
                      </div>
                    }
                  </li>

                  <li
                    style="z-index: 2;"
                    [class.downloadSuccess]="data.status==='DOWNLOAD_SUCCESS' || data.status==='ECU_FLASH'"
                    [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                    [class.cancelled]="data.status==='CANCELLED'"
                    [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                    <div class="status">
                      <span>Download Success</span>
                    </div>
                    <div class="status-dot"></div>
                    @if (data.downloadSuccessAt) {
                      <div class="timestamp">
                        <span class="date">{{ data.downloadSuccessAt | date: dateFormat }}</span>
                      </div>
                    }
                  </li>

                  <li
                    style="z-index: 1;"
                    [class.success]="data.status==='SUCCESS' || data.status === 'INSTALL_SUCCESS'"
                    [class.installSuccess]="data.status==='INSTALL_SUCCESS'"
                    [class.cancelled]="data.status==='CANCELLED'"
                    [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT' || data.status==='INSTALL_FAILED'">
                    <div class="status">
                      <span>{{ data.status==='INSTALL_FAILED' ? 'Install Failed' : 'Install Success' }}</span>
                    </div>
                    <div
                      class="status-dot"
                      [class.hover-enabled]="data.status==='INSTALL_SUCCESS' || data.status==='INSTALL_FAILED' || data.status==='TOO_MANY_ATTEMPT'"
                      [ngbTooltip]="tooltipContent(data)">
                    </div>
                    @if (data.installSuccessAt && data.status==='INSTALL_SUCCESS') {
                      <div class="timestamp">
                        <span class="date">{{ data.installSuccessAt | date: dateFormat }}</span>
                      </div>
                    }
                    @if (data.installFailedAt && data.status==='INSTALL_FAILED') {
                      <div class="timestamp">
                        <span class="date">{{ data.installFailedAt | date: dateFormat }}</span>
                      </div>
                    }
                  </li>

                  <li
                    style="z-index: 0;"
                    [class.success]="data.status==='SUCCESS'"
                    [class.cancelled]="data.status==='CANCELLED'"
                    [class.failed]="data.status==='FAILED' || data.status==='TOO_MANY_ATTEMPT'">
                    <div class="status">
                      @if (data.status==='SUCCESS') {
                        <span>Success</span>
                      }
                      @if (data.status==='CANCELLED') {
                        <span>Cancelled</span>
                      }
                      @if (data.status==='FAILED') {
                        <span>Failed</span>
                      }
                      @if (data.status==='TOO_MANY_ATTEMPT') {
                        <span>Too Many Attempts</span>
                      }
                      @if (data.status!=='SUCCESS' && data.status!=='CANCELLED' && data.status!=='FAILED' && data.status!=='TOO_MANY_ATTEMPT') {
                        <span>Success</span>
                      }
                    </div>
                    <div class="status-dot"></div>
                    @if (data.completedAt) {
                      <div class="timestamp">
                        <span class="date date--emphasis">{{ data.completedAt | date: dateFormat }}</span>
                        @if (data.status==='CANCELLED' && data.cancelledBy) {
                          <span class="date date--emphasis d-block">
                            <span class="dh-stage__author" ngbTooltip="Cancelled By">
                              <i class="fa fa-user" aria-hidden="true"></i>
                              {{ data.cancelledBy }}
                            </span>
                          </span>
                        }
                      </div>
                    }
                  </li>
                </ul>

                @if (data.errorCode || data.remark) {
                  <div class="dh-stage__error">
                    @if (data.errorCode) {
                      <label class="m-0">
                        Error:
                        <span class="text-danger">
                          {{ failStatus[data.errorCode] ? failStatus[data.errorCode] : data.errorCode }}
                        </span>
                      </label>
                    }
                    @if (data.errorCode) {
                      <br>
                    }
                    @if (data.remark) {
                      <label class="m-0">
                        Remark: <span class="text-danger">{{ data.remark }}</span>
                      </label>
                    }
                  </div>
                }
              </div>
            }

            @if (loadmore) {
              <div class="dh-load-more">
                <button type="button" class="dh-load-more__btn" (click)="loadMoreActivity()">
                  Load more
                </button>
              </div>
            }
          </div>
        }

        @if (!deviceHistoryView.length && !isLoading) {
          <div class="dh-empty">
            <span>No History.</span>
          </div>
        }

        @if (isLoading && !deviceHistoryView.length) {
          <div class="dh-empty">
            <span>Loading history…</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
